import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import {
    SCORE_BOOM_CARD,
    SCORE_BOOM_TARGET_CARD,
} from '../../../Constants/Score';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { IGameState } from '../../Game/IGameState';
import { ICardsState, ICardStateData } from '../ICardState';
import { initialCardStateData } from '../initialCardStateData';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { CardState } from 'Prototype/Level/Card/CardState';
import { ArrayHelper } from 'Utility/ArrayHelper';

export default class BoomCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = state.levelState.cardsState;
        const currentCardState = CardStateHelper.getCardState(
            cardsState,
            this.cardID
        );

        let targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            const boomCardData = cardsState.cards[this.cardID];
            const offsetBoom = boomCardData.offset ?? initialCardStateData.offset.clone();
            const removableCardIDs = cardsState.inPlay
                .filter(cardID => cardsState.cards[cardID].type === CardType.value);

            removableCardIDs.forEach((cardID: string) => {
                if (cardID === this.cardID) return; // Skip this card.

                const cardData = cardsState.cards[cardID];
                const offsetCard = cardData.offset ?? initialCardStateData.offset.clone();

                if (
                    cardData.type === CardType.gold ||
                    cardData.type === CardType.scissors ||
                    cardData.type === CardType.key ||
                    this.hasInvalidModifier(cardData)
                )
                    return;

                const dx = Math.abs(boomCardData.x + offsetBoom.x - cardData.x + offsetCard.x);
                const dy = Math.abs(boomCardData.y + offsetBoom.y - cardData.y + offsetCard.y);
                if (dx < 300 && dy < 360) {
                    const behavior = CardStateHelper.getCardBehavior(
                        cardsState,
                        cardID
                    );
                    if (
                        !behavior.isBlocked(cardsState) &&
                        behavior.getCardType(cardsState) !== CardType.lock
                    ) {
                        // Collect affected card IDs for task data.
                        targets.push(cardID);

                        const connectedModifiers = CardStateHelper.getModifiersOfType(cardsState, cardID, CardModifierType.connected);
                        connectedModifiers.forEach((connectedModifier) => {
                            if (connectedModifier.properties.cardID) {
                                targets.push(connectedModifier.properties.cardID)
                            }
                        });
                    }
                }
            });
        }

        // Discard self.
        cardsState = CardStateHelper.setCardDiscarded(cardsState, this.cardID);
        targets = targets.filter(ArrayHelper.filterOnce);
        targets.forEach(target => {
            cardsState = CardStateHelper.setCardDiscarded(cardsState, target)
        })

        // Add score.
        const scores: number[] = [
            SCORE_BOOM_CARD,
            ...Array(targets.length).fill(SCORE_BOOM_TARGET_CARD),
        ];
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger explosion task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.BOOM,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        targets.forEach((cardID) => {
            cardsState = CardStateModifierHelper.onCardDiscarded(
                cardsState,
                cardID
            );
        });

        // Update all cards behavior after some of them are discarded.
        cardsState = CardStateHelper.updateCards(cardsState);

        // Clear the undo history when a boom card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return {
            ...state,
            levelState: { ...state.levelState, cardsState },
        };
    }

    public hasInvalidModifier(cardData: ICardStateData): boolean {
        return cardData.modifiers.some(modifier => {
            return modifier.type === CardModifierType.rope;
        });
    }
    public hasInvalidType(cardData: ICardStateData): boolean {
        switch (cardData.type) {
            case CardType.key:
            case CardType.gold:
            case CardType.scissors:
            case CardType.boom:
                return false;
            default:
                return true;
        }
    }
}
